var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgChineseYuanRound(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12 22C17.5228 22 22 17.5228 22 12C22 6.47715 17.5228 2 12 2C6.47715 2 2 6.47715 2 12C2 17.5228 6.47715 22 12 22ZM8.58565 6.53148L12 10.7994L15.4143 6.53148C15.6731 6.20803 16.1451 6.15559 16.4685 6.41435C16.792 6.67311 16.8444 7.14507 16.5857 7.46852L12.7605 12.25H14.5C14.9142 12.25 15.25 12.5858 15.25 13C15.25 13.4142 14.9142 13.75 14.5 13.75H12.75V17.9999C12.75 18.4142 12.4142 18.7499 12 18.7499C11.5858 18.7499 11.25 18.4142 11.25 17.9999V13.75H9.5C9.08579 13.75 8.75 13.4142 8.75 13C8.75 12.5858 9.08579 12.25 9.5 12.25H11.2395L7.41435 7.46852C7.15559 7.14507 7.20803 6.67311 7.53148 6.41435C7.85493 6.15559 8.32689 6.20803 8.58565 6.53148Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChineseYuanRound);
export default __webpack_public_path__ + "static/media/chinese-yuan-round.8325b4eecd57d3eb83e341282f4a71d8.svg";
export { ForwardRef as ReactComponent };